import React, { useState } from 'react';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const sections = [
  { id: 'core', label: 'Basic Info', icon: Icon.User },
  { id: 'model', label: 'Model / LLM', icon: Icon.Cpu },
  { id: 'voice_speech', label: 'Voice & Speech', icon: Icon.Volume2 },
  { id: 'sentiment_fields', label: 'Sentiment Fields', icon: Icon.List }
];

const CallexAiAgentSettingsPage = ({ handleSubmit, children, validateForm }) => {
  const [active, setActive] = useState('core');

  const activeSection = sections.find((s) => s.id === active);
  const ActiveIcon = activeSection?.icon;

  const findErrorSection = (errors) => {
    if (
      errors.name ||
      errors.slug ||
      errors.status ||
      errors.language ||
      errors.process_id ||
      errors.description ||
      errors.welcome_message ||
      errors.prompt
    )
      return 'core';
    if (errors.llm_provider) return 'model';
    if (errors.voice_provider || errors.voice_id || errors.background_noise) return 'voice_speech';
    if (errors.sentiment_fields) return 'sentiment_fields';

    return null;
  };

  return (
    <div className="ai-settings-page">
      <div className="settings-layout">
        <div className="settings-sidebar">
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <div
                key={section.id}
                className={`sidebar-item ${active === section.id ? 'active' : ''}`}
                onClick={() => setActive(section.id)}>
                <IconComponent size={16} />
                <span>{section.label}</span>
              </div>
            );
          })}
        </div>

        <div className="settings-content">
          {/* HEADER */}
          <div className="settings-header">
            {ActiveIcon && <ActiveIcon size={16} />}
            <h6>{activeSection?.label}</h6>
          </div>

          {/* FORM CONTENT */}
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const formErrors = await validateForm();
              console.log('formErrors', formErrors);
              if (Object.keys(formErrors).length > 0) {
                const errorTab = findErrorSection(formErrors);
                if (errorTab) {
                  setActive(errorTab);
                  toast.error('Please complete all required fields.');
                }
              }
              handleSubmit();
            }}
            id="callex-ai-agent-form">
            {React.Children.map(children, (child) => (child?.props?.id === active ? child : null))}
          </form>
        </div>
      </div>
    </div>
  );
};

CallexAiAgentSettingsPage.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  validateForm: PropTypes.any
};

export default CallexAiAgentSettingsPage;
